import React, { useEffect, useState } from "react";

const IreInsertion = () => {
  const [entry, setEntry] = useState([]);
  const [allData, setAllData] = useState([]);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  useEffect(() => {
    const filedData = [
      keys.reduce((acc, key, index) => {
        if (key === "DATE") {
          acc[key] = entry[index] || new Date().toISOString().slice(0, 10);
        } else if (key === "inserted_by") {
          acc[key] = entry[index] || 3;
        } else {
          acc[key] = entry[index] || "";
        }
        return acc;
      }, {}),
    ];
    setAllData(filedData);
  }, [entry]);
  const keys = [
    "DATE",
    "JUMBO_RECD",
    "JUMBO_IRE",
    "JUMBO_Y_DAY_O_B",
    "NBOX_RECD",
    "NBOX_IRE",
    "NBOX_Y_DAY_O_B",
    "BTPN_RECD",
    "BTPN_IRE",
    "BTPN_Y_DAY_O_B",
    "inserted_by",
  ];

  const handleChange = (keyIndex, value) => {
    const newEntry = [...entry];
    newEntry[keyIndex] = value;
    setEntry(newEntry);
  };

  const handleClear = () => {
    setEntry([]);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${urlPrefix}insert/ire`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(allData),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }

    handleClear();
  };

  return (
    <div className="papaDiv">
      <h5 className="bg-dark text-white text-center">Insert Data in IRE</h5>
      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 ">
          <thead className="table-dark text-center align-middle">
            <tr>
              <th></th>
              <th colSpan={3}>JUMBO</th>
              <th colSpan={3}>NBOX</th>
              <th colSpan={3}>BTPN</th>
            </tr>
            <tr>
              {keys.map((key, i) =>
                key === "inserted_by" ? null : (
                  <th key={i} style={{ minWidth: "90px" }}>
                    {key

                      .replace("JUMBO_", " ")
                      .replace("id", "ID")
                      .replace("NBOX_", " ")
                      .replace("BTPN_", " ")
                      .replace("RECD", "RECEIVED")
                      .replace("Y_DAY_O_B", "YESTERDAY O/B")}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              {keys.map((key, index) =>
                key === "inserted_by" ? null : (
                  <td key={index}>
                    {key === "DATE" ? (
                      <input
                        type="date"
                        className="form-control"
                        style={{ width: "160px", fontSize: "0.8rem" }}
                        value={
                          entry[index] || new Date().toISOString().slice(0, 10)
                        }
                        onChange={(e) => handleChange(index, e.target.value)}
                      />
                    ) : (
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          height: "26px",
                          padding: "2px 6px",
                          fontSize: "0.8rem",
                        }}
                        value={entry[index] || ""}
                        onChange={(e) => handleChange(index, e.target.value)}
                      />
                    )}
                  </td>
                )
              )}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClear}
        >
          Clear
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Upload
        </button>
      </div>
    </div>
  );
};

export default IreInsertion;
